<template>
  <div class="cont app-container">
    <div class="left" :style="{width:isZhedie?'calc(100% - 60px)':'50%'}">
      <div class="formBox margbot" ref="searchBox">
        <el-form :inline="true" class="demo-form-inline" label-width="100px" size="mini">
          <div class="inpBox">
            <el-form-item label="所在仓库:" prop="organizationId">
              <el-select v-model="searchFrom.organizationId" placeholder="">
                <el-option v-for="val in warehouseList" :label="val.relTenantName" :value="val.relTenantCode" :key="val.relTenantCode"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="货物类型:" class="jiage" prop="productType">
              <el-select v-model="searchFrom.productType" value-key="productId">
                <el-option v-for="item in productTypes" :label="item.show_name" :value="item.item_no" :key="item.item_no"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="货权方:" prop="ownerCustomerName" v-if="tableArr[1]">
              <el-input placeholder="" v-model="searchFrom.ownerCustomerName"></el-input>
            </el-form-item>
            <el-form-item label="控货方:" prop="oneCustomerName" v-if="tableArr[0]">
              <el-input placeholder="" v-model="searchFrom.oneCustomerName"></el-input>
            </el-form-item>
            <el-form-item label="产地:" prop="steelMillName">
              <el-input placeholder="" v-model="searchFrom.steelMillName"></el-input>
            </el-form-item>
            <el-form-item label="规格:" prop="specification">
              <el-input placeholder="" v-model="searchFrom.specification"></el-input>
            </el-form-item>
            <el-form-item label="材质:" prop="model">
              <el-input placeholder="" v-model="searchFrom.model"></el-input>
            </el-form-item>
          </div>
          <div class="searchBtnBox">
            <el-form-item>
              <el-button type="primary" @click="searchFn">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="exportFn" :disabled="isDisable">导出</el-button>
            </el-form-item>
            <el-form-item>
              <p class="margin0">总件数：<span class="red">{{tongji.totalNumber}}</span>件</p>
            </el-form-item>
            <el-form-item>
              <p class="margin0">总重量：<span class="red">{{tongji.totalAllWeight}}</span>吨</p>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <!--  表格 -->
      <div class="table" :style="{height:h}">
        <el-table :data="tableList" ref="table" v-loading="loading" bordersize="mini" @row-click="yuxuanFN" style="width: 100%" height="100%" center border v-if="tableArr.length>0">
          <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
          <!-- <el-table-column label="操作" width="90" >
          <template slot-scope="scope">
            <div>
            <el-button type="text" size="mini"   @click="yuxuanFN(scope.row)">预选</el-button>
              </div>
          </template>
        </el-table-column> -->
          <el-table-column prop="oneCustomerName" min-width="150" v-if="tableArr[0]" :formatter="emptyFn" label="控货方"></el-table-column>
          <el-table-column property="productTypeName" width="100" label="货物类型"></el-table-column>
          <el-table-column property="steelMillName" width="150" label="产地"></el-table-column>
          <el-table-column property="specification" width="120" label="规格"></el-table-column>
          <el-table-column property="model" width="100" :formatter="emptyFn" label="材质"></el-table-column>
          <!-- <el-table-column property="root" width="120" :formatter="emptyFn"  label="单件支数"></el-table-column>
            <el-table-column property="length"  width="100" :formatter="emptyFn" label="长度(m)"></el-table-column> -->
          <el-table-column property="number" width="90" :formatter="emptyFn" label="总件数"></el-table-column>
          <el-table-column property="availableNumber" width="90" :formatter="emptyFn" label="可提件数"></el-table-column>
          <el-table-column property="singletonWeight" width="110" label="单件理重(吨)"></el-table-column>
          <el-table-column property="allWeight" width="90" label="总重量(吨)"></el-table-column>
          <el-table-column property="stockWeight" width="90" label="总理重(吨)"></el-table-column>
          <el-table-column property="stockPoundWeight" width="90" label="总磅重(吨)"></el-table-column>
          <!-- <el-table-column prop="plateNumber"  min-width="120" :formatter="emptyFn" label="车船号"></el-table-column>
            <el-table-column prop="shipForecastNo"  min-width="170" :formatter="emptyFn" label="预报编号"></el-table-column> -->
          <el-table-column property="organizationName" min-width="150" label="所在仓库"></el-table-column>
          <el-table-column prop="ownerCustomerName" min-width="150" v-if="tableArr[1]" :formatter="emptyFn" label="货权方"></el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div>
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchFrom.pageNo" :page-sizes="[50,100,200,1000]" :page-size="searchFrom.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <div class="zhedieBox" v-if="isZhedie" @click="zhedieFn(false)">
      <el-badge :value="addFrom.goodList.length">
        <span>预选清单</span>
      </el-badge>
      <i class="el-icon-d-arrow-left" style="font-size: 20px;"></i>
    </div>
    <div class="right" v-if="!isZhedie">
      <div class="detailsTitle" style="justify-content: start;">
        <h4>预选清单</h4>
        <div style="margin-left: 12px;font-size: 20px;color: #0c46a2;" @click="zhedieFn(true)"><i class="el-icon-d-arrow-right"></i></div>
      </div>
      <div class="rightCenter">
        <el-form :inline="true" :model="addFrom" ref="addFrom" :rules="rules" class="demo-form-inline jiaoyan" label-width="120px" size="mini">
          <div class="table" :style="{height:h1}">
            <div style="display:flex;align-items: center;">
              <div class="boxItem" v-if="tableArr[2]">
                <p class="margin0" style="white-space: nowrap;">剩余量<span class="red">{{yuWeight}}</span>吨</p>
              </div>
              <div class="boxItem">
                <el-button type="primary" @click="delAllFN">清空</el-button>
              </div>
              <div class="boxItem" v-if="addFrom.goodList.length>0&&tableArr[0]">
                <div class="name">控货方：</div>
                <div class="miaoshu miaoshu0" :title="addFrom.goodList[0].oneCustomerName">
                  {{addFrom.goodList[0].oneCustomerName?addFrom.goodList[0].oneCustomerName:'-'}}
                </div>
              </div>
              <div class="boxItem" v-if="addFrom.goodList.length>0">
                <div class="name">所在仓库：</div>
                <div class="miaoshu miaoshu0" :title="addFrom.goodList[0].organizationName">
                  {{addFrom.goodList[0].organizationName?addFrom.goodList[0].organizationName:'-'}}
                </div>
              </div>
            </div>
            <div class="box" v-for="(item,index) in addFrom.goodList" :key="index">
              <div class="xuhao">{{index+1}}</div>
              <div class="box1">
                <el-form-item label="" :prop="'goodList.' +index+ '.planNum'" :key="index" :rules="rules.planNum" class="table_error">
                  <el-input placeholder="" v-number-input.float="0" @input="maxFn(index,item.number)" maxlength="10" v-model.number="addFrom.goodList[index].planNum"></el-input>
                </el-form-item>
              </div>
              <div class="box2">
                <div class="box2Item" style="margin-bottom:6px">
                  <div class="boxItem" v-if="addFrom.goodList.length>0">
                    <div class="name">货物类型：</div>
                    <div class="miaoshu miaoshu1" style="max-width:200px" :title="item.productTypeName">
                      {{item.productTypeName?item.productTypeName:'-'}}
                    </div>
                  </div>
                  <div class="boxItem" v-if="addFrom.goodList.length>0">
                    <div class="name">规&nbsp;&nbsp;&nbsp;格：</div>
                    <div class="miaoshu2" style="max-width:200px" :title="item.specification">
                      {{item.specification?item.specification:'-'}}
                    </div>
                  </div>
                  <div class="boxItem" v-if="addFrom.goodList.length>0">
                    <div class="name">材&nbsp;&nbsp;&nbsp;质：</div>
                    <div class="miaoshu" style="max-width:200px" :title="item.model">
                      {{item.model?item.model:'-'}}
                    </div>
                  </div>
                  <div class="boxItem" v-if="addFrom.goodList.length>0">
                    <div class="name">产&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;地：</div>
                    <div class="miaoshu miaoshu3" style="max-width:200px" :title="item.steelMillName">
                      {{item.steelMillName?item.steelMillName:'-'}}
                    </div>
                  </div>
                </div>
                <div class="box2Item" style="margin-top:6px">
                  <div class="boxItem" v-if="addFrom.goodList.length>0">
                    <div class="name">处理重量：</div>
                    <div class="miaoshu miaoshu1" style="max-width:200px" :title="item.productTypeName">
                      {{item.planWeight?item.planWeight:'0'}}
                    </div>
                  </div>
                  <div class="boxItem" v-if="addFrom.goodList.length>0">
                    <div class="name">总重量：</div>
                    <div class="miaoshu2" style="max-width:200px" :title="item.allWeight">
                      {{item.allWeight?item.allWeight:'-'}}
                    </div>
                  </div>
                  <div class="boxItem" v-if="addFrom.goodList.length>0">
                    <div class="name">总件数：</div>
                    <div class="miaoshu" style="max-width:200px" :title="item.number">
                      {{item.number?item.number:'-'}}
                    </div>
                  </div>
                  <div class="boxItem" v-if="addFrom.goodList.length>0">
                    <div class="name">单件理重：</div>
                    <div class="miaoshu miaoshu3" style="max-width:200px" :title="item.singletonWeight">
                      {{item.singletonWeight?item.singletonWeight:'-'}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="" @click="delFN(index)"><i class="el-icon-delete"></i></div>
            </div>
          </div>
          <div>
            <el-form-item>
              <p class="margin0">总计处理件数<span class="red">{{addFrom.allNum}}</span>件</p>
            </el-form-item>
            <el-form-item>
              <p class="margin0">总计处理重量<span class="red">{{addFrom.allWeight}}</span>吨</p>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="rightBottom">
        <el-button type="primary" class="bigBtn" v-if="btnFlg[0]" :loading="btnLoading" @click="saveFn(1)">提货</el-button>
        <el-button type="primary" class="bigBtn" v-if="btnFlg[1]" :loading="btnLoading" @click="saveFn(2)">转货</el-button>
        <el-button type="primary" class="bigBtn" v-if="btnFlg[2]" :loading="btnLoading" @click="saveFn(3)">找车提货</el-button>
      </div>
    </div>
    <tihuo :row-data="addFrom" v-if="tihuoFlag" @destroy="destroy"></tihuo>
    <zhuanhuo :row-data="addFrom" v-if="zhuanhuoFlag" @destroy="destroy"></zhuanhuo>
  </div>
</template>

<script>
import { getBtn, getAttribute, getAttributeA } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat, toFixed } from '@/utils/util'
import tihuo from '@/views/soc-stock-cosco/inventoryMonitore/tihuo.vue'
import zhuanhuo from '@/views/soc-stock-cosco/inventoryMonitore/zhuanhuo.vue'
import {
  getDictionaryAll, getStockThreadList, getStockThreadTotalWN, getOrganizationNameList,
  surplusWeight, findExtAttritude, remaindeGoodsNum
} from '@/api/soc-stock-cosco'
import { exportExcel } from '@/utils/fileDown.js'
export default {
  components: {
    tihuo, zhuanhuo
  },
  data () {
    return {
      tableArr: [],
      isZhedie: false,
      h: 500,
      h1: 500,
      toFixed: toFixed,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      oneCustomerTaxId: localStorage.getItem('tenantTaxpayerNumber'),
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        flag: 3
      },
      total: 0,
      tongji: {},
      loading: 'false',
      productTypes: [],
      warehouseList: [],
      addFrom: {
        goodList: [],
        allWeight: 0,
        allNum: 0
      },
      strArr: [],
      yuWeight: 0, // 控货剩余量
      rules: {
        planNum: [{ required: true, message: '输入件数', trigger: 'blur' }]
      },
      tihuoFlag: false,
      zhuanhuoFlag: false,
      isDisable: false,
      btnLoading: false,
      isjianfa: false,
      btnFlg: [],
      btnIdArr: ['00UP002B001', '00UP002B002', '00UM020100']
    }
  },
  created () {
    this.tableArr = getAttribute('ARRoneCustomerName,ARRownerCustomerName,ARRisControl,ARRvalidityTime,ARRisCarHold,ARRoutBillNo,ARRdriverIdentityNo,ARRZYHZVHCNOZS,ARRdriverMobile')
    console.log(this.tableArr)
    this.btnFlg = getBtn(this.btnIdArr, '/ZYInventoryMonitore')
    this.searchFrom.twoCustomerTaxId = this.oneCustomerTaxId
    getDictionaryAll({ groupNo: 'thread_product_type' }).then(res => {
      this.productTypes = res
      this.productTypes.unshift({ show_name: '全部', item_no: '' })
    })
    if (localStorage.getItem('isCutCrm3') == 1) {
      this.warehouseList = [{
        relTenantName: localStorage.getItem('createTenantName'),
        relTenantCode: localStorage.getItem('createTenantCode')
      }]
      this.$set(this.searchFrom, 'organizationId', this.warehouseList[0].relTenantCode)
      // let orgName = this.warehouseList[0].relTenantName
      // if (orgName.indexOf('建发钢铁物流') != -1 || orgName.indexOf('首线联合') != -1 || orgName.indexOf('建发') != -1) {
      //   this.isjianfa = true
      //   this.searchFrom.janFaFlag = 1
      // }
      getAttributeA('ARRisSelfWarehouse', this.warehouseList[0].relTenantCode).then(res => {
        console.log(res)
        if (res[0] == 3) { // 是建发库
          this.isjianfa = true
          this.searchFrom.janFaFlag = 1
        }
        this.getList(this.searchFrom)
      })
    } else {
      getOrganizationNameList({
        userCode: localStorage.getItem('userCode'),
        tenantCode: localStorage.getItem('tenantCode')
      }).then(res => {
        this.warehouseList = res
        if (res.length > 0) {
          this.$set(this.searchFrom, 'organizationId', this.warehouseList[0].relTenantCode)
          let orgName = this.warehouseList[0].relTenantName
          if (orgName.indexOf('建发钢铁物流') != -1 || orgName.indexOf('首线联合') != -1) {
            this.isjianfa = true
            this.searchFrom.janFaFlag = 1
          }
        }
        this.getList(this.searchFrom)
      })
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 162) + 'px'
    this.h1 = (pH - 260) + 'px'
  },
  methods: {
    // 导出
    exportFn () {
      let falg = this.tableArr[0]
      let form = { ...this.searchFrom }
      form.primaryCustomerNameFlag = falg
      form.ownerCustomerNameFlag = this.tableArr[1]
      delete form.pageNo
      delete form.pageSize
      exportExcel(
        this.global.wmsStockName + '/recordDetails/exportStockThreadList',
        form,
        '库存记录'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    zhedieFn (flag) {
      this.isZhedie = flag
    },
    saveFn (n) { // 1、提货，2、转货
      if (this.strArr.length == 0) {
        this.$alert('预选清单不能为空', '系统提示')
      } else {
        this.$refs.addFrom.validate((valid) => {
          if (valid) {
            if (this.addFrom.goodList.some(item => !item.planNum)) {
              this.$alert('请输入货物件数', '系统提示')
              return
            }
            this.addFrom.zhanshiFLag = [this.tableArr[3], this.tableArr[4], this.tableArr[5], this.tableArr[6], this.tableArr[7], this.tableArr[8]]
            if (this.isjianfa) {
              this.addFrom.janFaFlag = 1
            }
            let allWeight = this.addFrom.allWeight
            // if (this.tableArr[2]) { // 是否控货字段得判断
            if (this.addFrom.goodList[0].oneCustomerTaxId != this.addFrom.goodList[0].twoCustomerTaxId) { // 一二级客户是否相同
              if (allWeight > this.yuWeight) {
                this.$alert('处理总重量不能超过剩余量', '系统提示')
              } else {
                if (n == 1) {
                  this.tihuoFlag = true
                } else if (n == 2) {
                  this.zhuanhuoFlag = true
                } else {
                  this.$router.push({
                    path: '/zhaocheTiHuo',
                    query: {
                      goodsList: this.addFrom
                    }
                  })
                }
              }
            } else {
              if (allWeight > this.yuWeight) {
                this.$confirm('您的处理重量已超出库存重量，是否继续操作?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消'
                }).then(() => {
                  if (n == 1) {
                    this.tihuoFlag = true
                  } else if (n == 2) {
                    this.zhuanhuoFlag = true
                  } else {
                    this.$router.push({
                      path: '/zhaocheTiHuo',
                      query: {
                        goodsList: this.addFrom
                      }
                    })
                  }
                }).catch(() => {

                })
              } else {
                if (n == 1) {
                  this.tihuoFlag = true
                } else if (n == 2) {
                  this.zhuanhuoFlag = true
                } else {
                  this.$router.push({
                    path: '/zhaocheTiHuo',
                    query: {
                      goodsList: this.addFrom
                    }
                  })
                }
              }
            }
            // } else {
            //   if (n == 1) {
            //     this.tihuoFlag = true
            //   } else if (n == 2) {
            //     this.zhuanhuoFlag = true
            //   } else {
            //     this.$router.push({
            //       path: '/zhaocheTiHuo',
            //       query: {
            //         goodsList: this.addFrom
            //       }
            //     })
            //   }
            // }
          }
        })
      }
    },
    destroy () {
      this.tihuoFlag = false
      this.zhuanhuoFlag = false
    },
    // 预选
    yuxuanFN (row) {
      if (row.ownerCustomerName) {
        this.$alert('当前货物因货权方限制，不能进行提/转货操作！', '系统提示')
        return
      }
      let str = JSON.stringify(row)
      let goodList = JSON.parse(JSON.stringify(this.addFrom.goodList))
      goodList.forEach(item => {
        delete item.planNum
        delete item.planWeight
      })
      let flag1 = goodList.every(value => JSON.stringify(value) != str)
      let flag2 = this.addFrom.goodList.every(value => value.oneCustomerTaxId == row.oneCustomerTaxId && value.organizationId == row.organizationId)
      if (!flag1) {
        this.$alert('此货物已在预选清单，不能重复添加', '系统提示')
      } else if (!flag2) {
        this.$alert('请选择同一控货方同一货权方相同仓库下的货物', '系统提示')
      } else {
        if (this.strArr.length == 0) {
          surplusWeight({
            oneCustomerTaxId: row.oneCustomerTaxId,
            organizationId: row.organizationId,
            twoCustomerTaxId: row.twoCustomerTaxId
          }).then(res => {
            this.yuWeight = res
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
              }
            })
          })
        }
        this.strArr.push(str)
        this.addFrom.goodList.push({ ...row })
      }
    },
    // 删除预选
    delFN (n) {
      this.addFrom.goodList.splice(n, 1)
      this.strArr.splice(n, 1)
      let allWeight = 0
      let allNum = 0
      this.addFrom.goodList.forEach(item => {
        if (item.planWeight) {
          allWeight += item.planWeight
          allNum += item.planNum
        }
      })
      this.addFrom.allWeight = this.toFixed(allWeight, 4)
      this.addFrom.allNum = this.toFixed(allNum, 0)
      if (this.addFrom.goodList.length == 0) {
        this.yuWeight = 0
        this.addFrom.allWeight = 0
        this.addFrom.allNum = 0
      }
    },
    // 清空
    delAllFN () {
      this.addFrom.goodList = []
      this.strArr = []
      this.yuWeight = 0
      this.addFrom.allWeight = 0
      this.addFrom.allNum = 0
    },
    // 限制输入最大及重量计算
    maxFn (n, max) {
      let num = this.addFrom.goodList[n].planNum
      // if (num > max) {
      //   this.$set(this.addFrom.goodList[n], 'planNum', max)
      // }
      if (max == 0 || num == 0) {
        this.$set(this.addFrom.goodList[n], 'planNum', '')
      } else {
        this.btnLoading = true
        remaindeGoodsNum(this.addFrom.goodList[n]).then(res => {
          if (this.addFrom.goodList[n].planNum > res) {
            this.$alert('您的处理件数已超出剩余件数，当前可处理件数为' + res + '件', '系统提示')
            this.$set(this.addFrom.goodList[n], 'planNum', '')
            this.$set(this.addFrom.goodList[n], 'planWeight', 0)
          } else {
            this.$set(this.addFrom.goodList[n], 'planWeight', this.accMul(this.addFrom.goodList[n].planNum, this.addFrom.goodList[n].singletonWeight))
          }
          let allWeight = 0
          let allNum = 0
          this.addFrom.goodList.forEach(item => {
            if (item.planWeight) {
              allWeight += item.planWeight
              allNum += item.planNum
            }
          })
          this.addFrom.allWeight = this.toFixed(allWeight, 4)
          this.addFrom.allNum = this.toFixed(allNum, 0)
          this.btnLoading = false
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
      }
    },
    // 乘法
    accMul (arg1, arg2) {
      var m = 0; var s1 = arg1.toString(); var s2 = arg2.toString()
      try {
        m += s1.split('.')[1].length
      } catch (e) {
      }
      try {
        m += s2.split('.')[1].length
      } catch (e) {
      }

      return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
    },
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      this.searchFrom.notHiddenColumnList = ['availableNumber']
      getStockThreadList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
      getStockThreadTotalWN(searchFrom).then(res => {
        this.tongji = res
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        flag: 3,
        pageNo: 1,
        pageSize: 50,
        twoCustomerTaxId: this.oneCustomerTaxId,
        organizationId: this.warehouseList[0].relTenantCode
      }
      if (this.isjianfa) {
        this.searchFrom.janFaFlag = 1
      }
      this.$set(this.searchFrom, 'organizationId', this.warehouseList[0].relTenantCode)
    },

    closeDialog () {
      this.addFrom = {}
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
      this.flag = false
    }
  }

}
</script>

<style scoped lang='less'>
.box {
  background: #fff;
  border-radius: 4px;
  box-shadow: 4px 2px 4px #ddd;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  box-sizing: border-box;
  padding-right: 10px;
  min-width: 100%;
  width: fit-content;
  .xuhao {
    padding-right: 12px;
    padding-left: 6px;
  }
  .box1 {
    border-left: 1px solid #ddd;
    /deep/.el-input__inner {
      height: 40px;
      line-height: 40px;
      margin: 0 6px;
      width: 60px;
      padding: 0 6px;
    }
  }
  .box2Item {
    height: 100%;
    display: flex;
    align-items: center;
  }
}
.boxItem {
  display: flex;
  font-size: 12px;
  margin-right: 15px;
  .name {
    white-space: nowrap;
    color: #909090;
  }
  .miaoshu {
    width: 60px;
    color: #101010;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
  }
  .miaoshu1 {
    width: 50px;
  }
  .miaoshu2 {
    width: 75px;
  }
  .miaoshu0 {
    width: 130px;
  }
}
@media (min-width: 1500px) {
  .box {
    .box1 {
      border-left: 1px solid #ddd;
      /deep/.el-input__inner {
        height: 40px;
        line-height: 40px;
        margin: 0 10px;
        width: 60px;
        padding: 0 6px;
      }
    }
    .box2Item {
      height: 100%;
      display: flex;
      align-items: center;
    }
    .boxItem {
      font-size: 14px;
      margin-right: 15px;
      .miaoshu {
        width: 70px;
      }
      .miaoshu1 {
        width: 60px;
      }
      .miaoshu2 {
        width: 100px;
      }
      .miaoshu0 {
        width: 170px;
      }
      .miaoshu3 {
        width: 100px;
      }
    }
  }
}
.rightCenter .table {
  overflow: auto;
}
/deep/.el-icon-delete {
  color: #0c46a2;
}
.cont {
  // height: 100%;
  height: calc(100vh - 42px - 35px - 42px);
  width: 100%;
  display: flex;
  box-sizing: border-box;
  .right {
    width: 50%;
    // height: calc(100% + 12px);
    // margin-top: -12px;
    padding-top: 12px;
    border-left: 5px solid #ddd;
    box-sizing: border-box;
    position: relative;
    // padding-bottom: 50px;
    .rightBottom {
      position: absolute;
      width: 100%;
      text-align: center;
      bottom: 10px;
      background: #fff;
    }
    .rightCenter {
      padding-left: 10px;
    }
  }
  .left {
    width: 50%;
    height: 100%;
    box-sizing: border-box;
  }
  .zhedieBox {
    width: 60px;
    border-left: 10px solid #ddd;
    margin-top: -12px;
    padding-top: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #8cb3e6;
    cursor: default;
    span {
      writing-mode: tb-rl;
      letter-spacing: 0.3em;
      color: #fff;
    }
    i {
      margin-top: 15px;
      color: #fff;
    }
    /deep/.el-badge__content {
      border: none;
      top: -8px;
    }
  }
}
.table_error /deep/.el-form-item__error {
  // top: 8px;
  // left: 5px;
}
/deep/.jiaoyan .el-form-item--mini.table_error {
  margin-bottom: 0 !important;
  margin: 14px 0 !important;
}
</style>
